import React, { useState, useEffect } from 'react';
import { Button, Popover, Typography } from '@material-ui/core';
import { ChromePicker } from 'react-color';
import { stylesColoPicker } from './stylesColoPicker';

const ColorPicker = ({ currentColor, onChange, label }) => {
    const classes = stylesColoPicker; //useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedColor, setSelectedColor] = useState(currentColor);
    const [tempColor, setTempColor] = useState(currentColor);

    useEffect(() => {
        setSelectedColor(currentColor);
        setTempColor(currentColor);
    }, [currentColor]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setTempColor(selectedColor); // en el picker, inicializar con el color actual
    };

    const handleClose = () => {
        setTempColor(selectedColor);
        setAnchorEl(null);
    };

    const handleChange = (color) => {
        setTempColor(color.hex); // actualizar el color temporal
    };

    const handleSave = () => {
        // actualizar el color seleccionado
        setSelectedColor(tempColor);
        onChange(tempColor);
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'color-popover' : undefined;

    return (
        <>
            <div style={{...classes.colorButton}} onClick={handleClick}>
                <div style={{ backgroundColor: selectedColor, ...classes.colorPreview }} />
                <Typography><strong>{label}</strong></Typography>
            </div>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                // classes={{ paper: classes.popover }}
                PaperProps={{
                    style: {
                        marginTop: 8,
                    },
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <div style={{ padding: '8px', backgroundColor: '#f5f5f5' }}>
                    <ChromePicker 
                        color={tempColor} 
                        onChange={handleChange}
                        styles={{
                            default: {
                                picker: {
                                    width: '100%',
                                },
                            },
                        }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSave}
                        style={{ marginTop: '5px', width: '100%' }}
                    >
                        Guardar color
                    </Button>
                    <Typography variant="caption" style={{ display: 'block', textAlign: 'center', marginTop: '6px', color: '#666' }}>
                        Haz click en "Guardar color" para confirmar
                    </Typography>
                </div>
            </Popover>
        </>
    );
};

export default ColorPicker;
